import { saveUtilityCache } from '../../../utils/utilityAppStorage';
import { create } from 'zustand';

// Cargar dato inicial del localStorage
const getInitialExercises = () => {
  try {
    const stored = localStorage.getItem('fitnessData');
    if (!stored) return getDefaultExercises();
    const data = JSON.parse(stored);
    return data.exercises || getDefaultExercises();
  } catch (e) {
    console.error('Error loading exercises:', e);
    return getDefaultExercises();
  }
};

const getDefaultExercises = () => [
  // Pecho
  { id: '1', name: 'Press de Banca', muscleGroup: 'pecho', type: 'push', defaultSets: 3, defaultReps: '8-12', defaultWeight: 80, notes: 'Con barra recta o mancuernas' },
  { id: '2', name: 'Press Inclinado', muscleGroup: 'pecho', type: 'push', defaultSets: 4, defaultReps: '8-10', defaultWeight: 70, notes: '' },
  { id: '3', name: 'Aperturas', muscleGroup: 'pecho', type: 'push', defaultSets: 3, defaultReps: '12-15', defaultWeight: 50, notes: 'Con mancuernas, tumbado' },
  { id: '25', name: 'Press Máquina', muscleGroup: 'pecho', type: 'push', defaultSets: 3, defaultReps: '10-12', defaultWeight: 60, notes: '' },

  // Espalda
  { id: '4', name: 'Dominadas', muscleGroup: 'espalda', type: 'pull', defaultSets: 4, defaultReps: '6-10', defaultWeight: 0, notes: 'Solo peso corporal' },
  { id: '5', name: 'Jalón Frontal', muscleGroup: 'espalda', type: 'pull', defaultSets: 4, defaultReps: '8-10', defaultWeight: 60, notes: '' },
  { id: '6', name: 'Remo en T', muscleGroup: 'espalda', type: 'pull', defaultSets: 4, defaultReps: '8-10', defaultWeight: 70, notes: '' },
  { id: '26', name: 'Remo Mancuerna a Una Mano', muscleGroup: 'espalda', type: 'pull', defaultSets: 3, defaultReps: '10-12', defaultWeight: 50, notes: 'Tumbado o apoyando una rodilla' },
  { id: '27', name: 'Pullover', muscleGroup: 'espalda', type: 'pull', defaultSets: 3, defaultReps: '12-15', defaultWeight: 40, notes: 'Con mancuerna, tumbado' },
  { id: '28', name: 'Peso Muerto Rumano', muscleGroup: 'espalda', type: 'pull', defaultSets: 3, defaultReps: '10-12', defaultWeight: 80, notes: 'Con barra o mancuernas' },

  // Piernas
  { id: '7', name: 'Sentadillas', muscleGroup: 'piernas', type: 'legs', defaultSets: 4, defaultReps: '6-8', defaultWeight: 100, notes: '' },
  { id: '8', name: 'Leg Press', muscleGroup: 'piernas', type: 'legs', defaultSets: 4, defaultReps: '8-10', defaultWeight: 150, notes: '' },
  { id: '9', name: 'Extensiones de Pierna', muscleGroup: 'piernas', type: 'legs', defaultSets: 3, defaultReps: '10-12', defaultWeight: 60, notes: '' },
  { id: '29', name: 'Sentadilla Goblet', muscleGroup: 'piernas', type: 'legs', defaultSets: 3, defaultReps: '10-12', defaultWeight: 30, notes: 'Con mancuerna' },
  { id: '30', name: 'Sentadilla Búlgara', muscleGroup: 'piernas', type: 'legs', defaultSets: 3, defaultReps: '8-10', defaultWeight: 25, notes: 'Con mancuerna por pierna' },
  { id: '31', name: 'Elevación de Talones', muscleGroup: 'piernas', type: 'legs', defaultSets: 3, defaultReps: '15-20', defaultWeight: 40, notes: 'Con mancuerna o pie' },
  { id: '32', name: 'Flexiones Isquiotibiales', muscleGroup: 'piernas', type: 'legs', defaultSets: 3, defaultReps: '10-12', defaultWeight: 50, notes: '' },

  // Hombros
  { id: '33', name: 'Press de Hombros', muscleGroup: 'hombros', type: 'push', defaultSets: 3, defaultReps: '10-12', defaultWeight: 40, notes: 'Con mancuernas, sentado o de pie' },
  { id: '34', name: 'Elevaciones Laterales', muscleGroup: 'hombros', type: 'push', defaultSets: 3, defaultReps: '12-15', defaultWeight: 20, notes: 'Con mancuernas' },

  // Brazos
  { id: '10', name: 'Curl de Bíceps', muscleGroup: 'brazos', type: 'pull', defaultSets: 3, defaultReps: '8-12', defaultWeight: 30, notes: '' },
  { id: '11', name: 'Tríceps en Polea', muscleGroup: 'brazos', type: 'push', defaultSets: 3, defaultReps: '10-12', defaultWeight: 40, notes: '' },
  { id: '35', name: 'Extensiones de Tríceps', muscleGroup: 'brazos', type: 'push', defaultSets: 3, defaultReps: '10-12', defaultWeight: 25, notes: 'Por encima de la cabeza, tumbado o de pie' },
  { id: '36', name: 'Press Francés', muscleGroup: 'brazos', type: 'push', defaultSets: 3, defaultReps: '12', defaultWeight: 20, notes: 'Con barra W o mancuernas' },
  { id: '37', name: 'Curl Martillo', muscleGroup: 'brazos', type: 'pull', defaultSets: 3, defaultReps: '10-12', defaultWeight: 25, notes: 'Palmas enfrentadas' },
  { id: '38', name: 'Curl Barra W', muscleGroup: 'brazos', type: 'pull', defaultSets: 3, defaultReps: '12', defaultWeight: 20, notes: 'De pie, palmas hacia arriba' },
  { id: '39', name: 'Curl de Muñeca', muscleGroup: 'brazos', type: 'pull', defaultSets: 3, defaultReps: '15-20', defaultWeight: 15, notes: 'Para antebrazos' },

  // Core
  { id: '12', name: 'Abdominales', muscleGroup: 'core', type: 'core', defaultSets: 3, defaultReps: '15-20', defaultWeight: 0, notes: '' },
  { id: '40', name: 'Crunch Abdominal', muscleGroup: 'core', type: 'core', defaultSets: 3, defaultReps: '15-20', defaultWeight: 0, notes: '' },
  { id: '41', name: 'Plancha', muscleGroup: 'core', type: 'core', defaultSets: 3, defaultReps: '30-60seg', defaultWeight: 0, notes: 'Mantener posición' },
  { id: '42', name: 'Elevación de Piernas', muscleGroup: 'core', type: 'core', defaultSets: 3, defaultReps: '15-20', defaultWeight: 0, notes: 'Tumbado' },
];

// Helper para guardar en localStorage unificado
const saveToLocalStorage = (state) => {
  try {
    const current = localStorage.getItem('fitnessData');
    const allData = current ? JSON.parse(current) : {};
    allData.exercises = state.exercises;
    saveUtilityCache('fitnessData', allData);
  } catch (e) {
    console.error('Error saving exercises:', e);
  }
};

export const useExerciseStore = create((set, get) => ({
  exercises: getInitialExercises(),

  addExercise: (exercise) =>
    set((state) => {
      const newState = {
        exercises: [...state.exercises, { id: Date.now().toString(), ...exercise }],
      };
      saveToLocalStorage(newState);
      return newState;
    }),

  updateExercise: (id, updates) =>
    set((state) => {
      const newState = {
        exercises: state.exercises.map((ex) => (ex.id === id ? { ...ex, ...updates } : ex)),
      };
      saveToLocalStorage(newState);
      return newState;
    }),

  deleteExercise: (id) =>
    set((state) => {
      const newState = {
        exercises: state.exercises.filter((ex) => ex.id !== id),
      };
      saveToLocalStorage(newState);
      return newState;
    }),

  getExercisesByMuscleGroup: (muscleGroup) =>
    get().exercises.filter((ex) => ex.muscleGroup === muscleGroup),
}));

export const rehydrateExercises = () => useExerciseStore.setState({ exercises: getInitialExercises() });
